import { Box, Typography, InputBase, Select, MenuItem, Paper as PaperMui } from "@mui/material"
import { styled } from "@mui/material/styles"
import { Link } from "react-router-dom"

export const Header = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  maxWidth: "500px",
}))

export const SearchBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "1rem",
  justifyContent: "space-between",
  width: "100%",
})

export const Search = styled(InputBase)(({ theme }) => ({
  width: "100%",
  [theme.breakpoints.between(0, 460)]: {
    marginLeft: "auto",
    width: "100%",
  },
}))

export const ButtonFilter = styled("button")({
  maxWidth: "7.43rem",
  minHeight: "3rem",
  background: "#89BD23",
  borderRadius: "0.5rem",
  fontSize: "0.9rem",
  fontFamily: "Roboto",
  fontWeight: 500,
})

export const TextButton = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.between(0, 537)]: {
    textIndent: "-99999px",
  },
}))

export const QuantityFilter = styled(Box)({
  marginLeft: "0.3rem",
})

export const MenuItemStyled = styled(MenuItem)({
  display: "flex",
  margin: "0.3rem 0",
  borderRadius: "6px",
  justifyContent: "flex-start",
  "&:hover": {
    background: "#EDF2EC",
  },
})

export const ButtonEdit = styled("button")(({ theme }) => ({
  minWidth: "7.1rem",
  minHeight: "3rem",
  border: "1px solid #6E8247",
  borderRadius: "0.5rem",
  color: "#6E8247",
  [theme.breakpoints.between(0, 507)]: {
    marginTop: "1rem",
  },
}))

export const Content = styled(Box)({
  padding: "2.5rem 2rem",
  minWidth: "600px",
  overflowX: "auto",
})

export const HeaderContent = styled(Box)({
  width: "100%",
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr",
  textTransform: "capitalize",
  color: "#414141",
  fontSize: "1.125rem",
  padding: "0 2rem",
  marginBottom: "1rem",
  "& strong": {
    fontWeight: 500,
    flex: 1,
    color: "#757575",
  },
})

export const BoxItem = styled(Box)({
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr",
  columnGap: "1rem",
  marginTop: "1.1rem",
  padding: "0 2rem 1rem 2rem",
})

export const ContainerInput = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
})

export const InputExtraOrder = styled(InputBase)({
  height: "2.5rem",
  maxWidth: "100px",
  border: "none !important",
  color: "#353535",
  fontWeight: 600,
  "&::webkit-inner-spin-button": {
    "-webkit-appearance": "none",
  },
  "& > .MuiInputBase-root": {
    height: "2.5rem",
    fontWeight: 500,
    backgroundColor: "#F4F4F4",
    borderRadius: "8px",
  },
  "& fieldset": {
    border: "none !important",
  },
})

export const ItemTitle = styled(Typography)({
  textAlign: "left",
  fontFamily: "Roboto",
  fontWeight: 500,
  fontSize: "1.1rem",
  lineHeight: "150%",
  color: "#353535",
})

export const SelectForm = styled(Select)({
  width: "146px",
  height: "40px",
  borderRadius: "30px",
  color: "#757575",
  fontWeight: 400,
  backgroundColor: "#E9F4D2 !important",
  "& fieldset": {
    border: "none !important",
  },
  "& svg": {
    fontSize: "27px",
    paddingRight: "3px",
  },
  "& .MuiSelect-selectMenu:focus": {
    background: "none !important",
    backgroundColor: "none !important",
  },
})

export const WithoutLevel = styled(Box)({
  backgroundColor: "#F4F4F4 !important",
})

export const DividerStyled = styled("div")({
  width: "100%",
  "&:first-child": {
    background: "transparent",
  },
})

export const BoxUrl = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",
})

export const BoxLink = styled(Link)({
  cursor: "pointer",
  color: "#757575",
  fontSize: "1.3rem",
  border: "none",
  background: "transparent",
  fontWeight: 500,
  textDecoration: "none",
  transition: "0.2s",
  "&:hover": {
    textDecoration: "underline",
  },
})

export const BoxPlace = styled(Box)({
  color: "#353535",
  fontSize: "1.3rem",
  fontWeight: 500,
  lineHeight: "1.5rem",
})

export const BoxAlign = styled(Box)({
  marginTop: "0.5rem",
  display: "flex",
  justifyContent: "space-between",
})

export const ContainerConfig = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  margin: "1rem 0 ",
})

export const Configs = styled("div")({
  border: "0.5px solid #757575",
  color: "#757575",
  fontSize: "1rem",
})

export const TitlePage = styled(Typography)({
  color: "#353535",
  fontSize: "1.6rem",
  fontFamily: "Inter",
  fontWeight: 600,
  lineHeight: "1.7rem",
  letterSpacing: "0.01em",
})

export const ContainerSelect = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "row",
})

export const ContainerPopover = styled(Box)({
  maxHeight: "300px",
  overflow: "auto",
  "&::-webkit-scrollbar": {
    width: "4px",
    background: "transparent",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#A1CA4F",
    borderRadius: "9px",
  },
})

export const CheckBoxStep = styled(Box)({
  padding: "0 .5rem 0 0",
})

export const ContainerScroll = styled(Box)({
  overflow: "auto",
  "&::-webkit-scrollbar": {
    width: "4px",
    background: "transparent",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#A1CA4F",
    borderRadius: "9px",
  },
})

export const ButtonManyEdit = styled("button")({
  border: "0.5px solid #89BD23",
  color: "white",
  fontSize: "1rem",
  backgroundColor: "#89BD23",
  marginRight: "1rem",
  "&:hover": {
    backgroundColor: "#89BD23",
    filter: "brightness(0.9)",
  },
})

export const ContainerManyEdit = styled(Box)({
  width: "100%",
  maxWidth: "100%",
  marginLeft: "auto",
  display: "flex",
  justifyContent: "space-between",
})

export const ButtonSave = styled("button")({
  border: "0.5px solid #89BD23",
  color: "white",
  fontSize: "1rem",
  backgroundColor: "#89BD23",
  marginRight: "1rem",
  "&:hover": {
    backgroundColor: "#89BD23",
    filter: "brightness(0.9)",
  },
  "&:disabled": {
    backgroundColor: "#E5E5E5",
    border: "0.5px solid #E5E5E5",
    opacity: 0.9,
  },
})

export const ContainerPage = styled(PaperMui)(({ theme }) => ({
  maxWidth: "1400px",
  margin: "0 auto 0 auto",
  padding: "1rem",
  height: "calc(100vh - 6.25rem - 5px)",
  display: "flex",
  flexDirection: "column",
  background: "transparent",
  boxShadow: "none",
}))
